import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const IMG = "/assets/img/teach";

export default function BecomeTutorArea(){
  const { t } = useTranslation();
  const location = useLocation();
  const prefix = location.pathname.startsWith("/app") ? "/app" : "";

  const selector = useSelector((state) => state.appearanceReducer );
  const appearanceData = selector?.data;

  const points = [
    t("becomeTeach.set_your_own_rate"),
    t("becomeTeach.teach_anytime"),
    t("auth.panel_tutor_point_3"),
  ];

  return (
    <section className="becomeTutorArea">
      <div className="container">
        <div className="bt-card">
          <div className="row g-0 align-items-stretch">
            <div className="col-lg-6">
              <div className="bt-visual">
                <img className="bt-cutout" src={`${IMG}/tutor-cutout.webp`} alt={t('becomeTutorArea.tutor_image_alt')} loading="lazy" />
                <div className="bt-inset" aria-hidden="true">
                  <img src={`${IMG}/tutor-inset.jpg`} alt="" loading="lazy" />
                </div>
                <div className="bt-badge" aria-hidden="true">
                  <span className="bt-badge-icon"><i className="fa-solid fa-calendar-check" /></span>
                  <div>
                    <strong>{t("becomeTeach.badge_booking_title")}</strong>
                    <span>{t("becomeTeach.badge_booking_time")}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="bt-content">
                <span className="bt-eyebrow">
                  <span className="bt-eyebrow-dot" /> {t("becomeTeach.eyebrow")}
                </span>
                <h2>{appearanceData?.tutor_area_header || t("becomeTeach.get_paid_online")}</h2>
                <p>{appearanceData?.tutor_area_details || t("becomeTeach.connect_with_learners")}</p>
                <ul className="bt-points">
                  {points.map((point, i) => (
                    <li key={i}>
                      <span className={`bt-check bt-check--${i + 1}`}><i className="fa-solid fa-check" /></span>
                      {point}
                    </li>
                  ))}
                </ul>
                <Link to={`${prefix}/teach`} className="bt-btn">
                  {t('becomeTutorArea.become_a_tutor_now')} <i className="fa-light fa-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
